import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { RichTextDisplay } from '@factorialco/factorial-one-react/dist/experimental'

import { Question } from 'modules/form_answers/lib/types'

import RatingTag from './RatingTag'

interface AnswerBoxProps {
  answer: string | { id: string; label: string }[] | undefined
  onClick?: () => void
  type: string
  question: Question
  comment?: string
}

const AnswerBox: React.FC<AnswerBoxProps> = ({ question, type, answer, onClick, comment }) => {
  const ratingLabel =
    typeof answer === 'string'
      ? question.scale.find((item) => item.value === answer)?.text ?? answer
      : ''

  return (
    <Box.Motion
      width="full"
      height="full"
      minHeight="s140"
      alignItems="flexStart"
      justifyContent="flexStart"
      borderRadius={{ all: 'abs008' }}
      border={{ all: { color: 'grey400', width: 's1', style: 'solid' } }}
      padding="s16"
      cursor="pointer"
      gap="s8"
      onClick={onClick}
    >
      {type === 'rating' && typeof answer === 'string' ? (
        <>
          {answer && <RatingTag label={ratingLabel} ratingValue={answer} />}
          {comment && (
            <Text.Normal size="200" lineClamp={5}>
              {comment}
            </Text.Normal>
          )}
        </>
      ) : Array.isArray(answer) ? (
        answer.map((a, index) => (
          <Text.Normal key={index} size="200" lineClamp={5}>
            {a.label}
          </Text.Normal>
        ))
      ) : (
        <RichTextDisplay
          style={{ maxHeight: '110px', overflow: 'hidden' }}
          content={answer || ''}
        />
      )}
    </Box.Motion>
  )
}

export default AnswerBox
